export const tutorialsModal = {
  dom: {
    allContainers: null,
    lines: null,
    button: null,
  },
  settings: {
    currentIndex: 1,
    uuid: null,
  },
  init() {
    this.dom.body = document.querySelector('body');
    this.dom.tutorialBody = document.querySelector('.js-tutorial-body');
    this.dom.allContainers = document.querySelectorAll('.js-container');
    this.dom.lines = document.querySelector('.js-lines-container');
    this.dom.button = document.querySelector('.js-bt');
    this.settings.uuid = document.querySelector('#uuid').textContent;
    this.settings.tutorial = this.dom.button.dataset.tutorial;
    this.settings.route = this.dom.button.dataset.route;
    this.dom.button && this.dom.button.addEventListener('click', this.switchContent.bind(this));
  },
  switchContent() {
    if (this.settings.currentIndex === this.dom.allContainers.length) {
      const host = window.getHost();
      const url = host + `/api/customers/${this.settings.uuid}/tutorial`;
      const requestBody = { tutorial: this.settings.tutorial, route: this.settings.route };
      this.dom.button.disabled = true;
      fetcher.post(url, requestBody, { Accept: 'application/json' }).then(response => {
        response.success && this.dom.tutorialBody.classList.add('hidden');
        this.dom.body.classList.remove('overflow-hidden', 'fixed');
        this.dom.body.classList.add('overflow-x-hidden');
        this.dom.button.disabled = false;
      });

      return;
    }

    if (this.settings.currentIndex > 0 && this.settings.currentIndex <= this.dom.allContainers.length - 1) {
      const currentContainer = this.dom.allContainers[+this.settings.currentIndex];
      const currentLine = this.dom.lines.children[+this.settings.currentIndex - 1];

      if (currentLine.classList.contains('bg-theta')) {
        currentLine.classList.replace('w-[24px]', 'w-[10px]');
        currentLine.classList.replace('bg-theta', 'bg-ecma');

        let nextLine = this.dom.lines.children[+this.settings.currentIndex];

        nextLine.classList.replace('w-[10px]', 'w-[24px]');
        nextLine.classList.replace('bg-ecma', 'bg-theta');
      }

      this.dom.allContainers.forEach(element =>
        element.classList.contains('hidden') ? '' : element.classList.add('hidden'),
      );

      currentContainer.classList.toggle('hidden');
      this.settings.currentIndex += 1;
    }
  },
};

document.addEventListener('DOMContentLoaded', () => {
  tutorialsModal.init();
});
